import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';
import { ArrowBackRounded } from '@mui/icons-material';
import apis from '@src/apis';
import { NEW_AUDIO_STATUS, VOICE_STATUS } from '@src/constants/voiceCloning';
import { StyledNoteRecordingAgain } from './index.style';

const NoteRecordingAgain = ({ audios, onPreviousStep, onNextStep }) => {
  const { t } = useTranslation();
  const { voiceId } = useParams();
  const history = useHistory();

  const handleRecordAgain = async () => {
    const res = await apis.voiceCloning.updateVoiceCloningVoice(voiceId, {
      status: VOICE_STATUS.RECORDING,
    });
    if (!res.status) return;

    const firstFailedAudio = audios.find(
      (audio) => audio.status === NEW_AUDIO_STATUS.FAILED,
    );
    const url = new URL(window.location.href);
    url.searchParams.set('sentenceCode', firstFailedAudio?.sentence?.code);
    history.push(url.pathname + url.search);
    onNextStep();
  };

  const SentencesFailed = () => (
    <Grid container spacing={2}>
      {audios?.map(
        (audio, index) =>
          audio?.status === NEW_AUDIO_STATUS.FAILED && (
            <Grid item key={audio?.id}>
              <Box className="sentence-box">
                <Typography className="sentence-text">{index + 1}</Typography>
              </Box>
            </Grid>
          ),
      )}
    </Grid>
  );

  return (
    <StyledNoteRecordingAgain>
      <Box className="top">
        <Button className="arrow-button">
          <ArrowBackRounded
            className="arrow-right-icon"
            onClick={onPreviousStep}
          />
        </Button>
        <Typography className="top-text">{t('listErrorSentences')}</Typography>
      </Box>
      <Box className="center">
        <SentencesFailed />
      </Box>
      <Box className="bottom">
        <Box className="note">
          <Typography className="note-text">
            {t('noteRecordingAgain')}
          </Typography>
        </Box>
        <Button
          fullWidth
          variant="contained"
          className="action-button"
          onClick={handleRecordAgain}
        >
          <Typography className="button-text">{t('startRecording')}</Typography>
        </Button>
      </Box>
    </StyledNoteRecordingAgain>
  );
};

export default NoteRecordingAgain;
